import request from '@/utils/request'


export function listBankAccount(query) {
  return request({
    url: '/biz/admin/merchant/bank/account/list',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function defaultBankAccount(query) {
  return request({
    url: '/biz/admin/merchant/bank/account/default',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function addBankAccount(data) {
  return request({
    url: '/biz/admin/merchant/bank/account/add',
    method: 'post',
    data: data
  })
}

export function getBankAccount(data) {
  return request({
    url: '/biz/admin/merchant/bank/account/detail',
    method: 'post',
    data: data
  })
}

export function updateBankAccount(data) {
  return request({
    url: '/biz/admin/merchant/bank/account/edit',
    method: 'post',
    data: data
  })
}

// 删除商家申请
export function delBankAccount(data) {
  return request({
    url: '/biz/admin/merchant/bank/account/delete',
    method: 'post',
    data: data
  })
}
